import { post, downLoadFile } from '../../xhr/fetch'
import { OPERATION_CENTER_PREFIX } from '../../config'

// 设备列表
export const GET_DEVICE_LIST = (data) => {
  return post(`${OPERATION_CENTER_PREFIX}/statistics/v1/vr/page`, data)
}

// 导出设备列表
export const EXPORT_DEVICE_LIST = (data) => {
  return downLoadFile(
    `${OPERATION_CENTER_PREFIX}/statistics/v1/vr/export`,
    data
  )
}
